window.addEventListener('DOMContentLoaded', function() {
    function removeActiveTabLink() {
        document.querySelectorAll('.tab-link').forEach(button => button.classList.remove('tab-link--active'));
    }
  
    document.querySelectorAll('.tab-link').forEach(button => {
  
        button.addEventListener('click', () => {
          const tabIndex = button.getAttribute('data-tab');
  
          removeActiveTabLink();
  
          document.querySelectorAll('.tab-pane').forEach(pane => {
            setTimeout(() => {
              if (pane.id === `tab-${tabIndex}`) {
                button.classList.add('tab-link--active');
                pane.classList.add('tab-pane--active');
              } else {
                pane.classList.remove('tab-pane--active');
              }
            }, 125);
          });
        });
    });
  
    const tabsEl = document.querySelector('.tabs');
  
    if (tabsEl && window.screen.width < tabsEl.scrollWidth) {
        document.querySelectorAll('.tab-link').forEach(button => {
            if (button.classList.contains('tab-link--active')) {
                tabsEl.parentElement.scrollTo({
                    top: 0,
                    left: button.parentElement.offsetLeft * 0.7,
                    behavior: "smooth",
                });
            }
  
            button.addEventListener('click', () => {
                tabsEl.parentElement.scrollTo({
                    top: 0,
                    left: button.parentElement.offsetLeft * 0.7,
                    behavior: "smooth",
                });
            });
        });
    }
});